import React ,{Component} from 'react'
import Header from './Header'
import Footer from './Footer'

class InnerLayout extends Component {

 
    render(){
        return(<>
             <Header />
               {this.props.children}
             <Footer />
        </>)
    }
}

export default InnerLayout;